module.exports = __webpack_public_path__ + "media/pages/Home/images/BestInClass-f66f331ae18fd4840c82a567f459bd21.jpg";